import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useEffectOnce from 'react-use/lib/useEffectOnce';
import { Header } from './components/Header/Header';
import { Goal } from './components/Goal/Goal';
import { useGoal } from './hooks/useGoal';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { resetState } from './state/actions';
import { Footer } from './components/Footer/Footer';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';
import { useResetModuleWrapperStyles } from '../../_hooks/useResetModuleWrapperStyles';
import { Content } from './GoalPage.styles';
import { FullPageLoading } from '../../CommonComponents/OPL/FullpageLoading/FullPageLoading';
import { ScrollHereOnce } from '../../CommonComponents/ScrollHereOnce';
import { setOpen as setWhatIfsOpen } from '../../WhatIfs/WhatIfsActions';
import { useRouteParams } from './hooks/useRouteParams';
import { GoalTypeDTO } from '../types/goalsDTO';
import { EstatePlanningGoalTabs } from './GoalPage.constants';

export const GoalPage = () => {
  const { isIdle, isError, refetch } = useGoal();

  const dispatch = useDispatch();

  const { clientId, goalId, tab } = useRouteParams();

  const { data: goal } = useGoal(goalId);

  useResetModuleWrapperStyles();

  useEffect(() => {
    if (
      goal &&
      goal.GoalType === GoalTypeDTO.EstatePlanning &&
      tab !== EstatePlanningGoalTabs.EstateFlow
    ) {
      dispatch(setWhatIfsOpen(clientId, false));
    }
  }, [clientId, dispatch, goal, tab]);

  useEffectOnce(() => () => {
    dispatch(resetState());

    dispatch(setWhatIfsOpen(clientId, false));
  });

  useDocumentTitle('Goal');

  if (isIdle) {
    return <FullPageLoading text="Loading..." size="medium" />;
  }

  if (isError) {
    return (
      <Box display="flex" alignItems="center" justifyContent="center" mt="56">
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  return (
    <Box minWidth={1000}>
      <ScrollHereOnce options={false} />

      <Content>
        <Header />

        <Goal mt="16" />
      </Content>

      <Footer mt="16" />
    </Box>
  );
};
